import React from "react";
import Header8 from "./../Common/Header8";
import Footer from "./../Common/Footer";
import Slider2 from "./../Elements/Slider2";
import About1 from "./../Elements/About1";
import About3 from "./../Elements/About3";
import WhatWeDo1 from "./../Elements/WhatWeDo1";
import Testimonials1 from "./../Elements/Testimonials1";
import Services1 from "./../Elements/Services1";
import Projects1 from "./../Elements/Projects1";
import Projects3 from "./../Elements/Projects3";
import Galleries from "./../Elements/Galleries";
import ClientsLogo1 from "./../Elements/ClientsLogo1";
import Objectives from "./../Elements/Objectives";
import Blog1 from "./../Elements/Blog1";
import Video from "./../Elements/Video";
import Statistics1 from "./../Elements/Statistics1";
import Video2 from "./../Elements/Video2";
import Video3 from "./../Elements/Video3";

class Home1 extends React.Component {
  render() {
    return (
      <>
        <Header8 />
        <div className="page-content">
          <Slider2 />
          <About1 />
          {/* <Objectives /> */}

          <Testimonials1 />
          <ClientsLogo1 />
          <Projects3
            alignment="separator-center"
            title="Nos Projets"
            bgcolor="bg-white"
          />
          {/* <Statistics1/> */}
          {/* <Video2/> */}
          <Video3/>
          {/* <Video alignment="separator-left" title="Nos Projets" /> */}
         
          <Galleries />
          
          <Blog1 bgcolor="bg-gray" />
          {/* <Team1 /> */}
          <div className="whatsapp-button">
            <link
              rel="stylesheet"
              href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css"
            />
            <a
              // href="https://api.whatsapp.com/send?phone=51955081075&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20Varela%202."
              href="https://api.whatsapp.com/send?phone=212600000000"
              className="float"
              target="_blank"
            >
              <i className="fa fa-whatsapp my-float"></i>
            </a>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default Home1;
